import './NavBar.scss';
import React from 'react';
import PropTypes from 'prop-types';
import MobileMenuToggle from 'components/nav/shared/MobileMenuToggle';
import AuthenticatedNavBar from 'components/nav/authenticated/AuthenticatedNavBar';
import UnauthenticatedNavBar from 'components/nav/unauthenticated/UnauthenticatedNavBar';

const NavBar = ({
  account,
  currentIdentity,
  hideJoinLink,
  identities,
  isNavMenuOpen,
}) => {
  const showAuthenticatedNavBar = (account && currentIdentity);
  return (
    <div className="aa-navbar">
      {isNavMenuOpen ? (
        <div
          className="nav-menu-background"
          data-target={MobileMenuToggle.Constants.dataTarget}
          data-toggle={MobileMenuToggle.Constants.dataToggle}
        />
      ) : null}
      {showAuthenticatedNavBar ? (
        <AuthenticatedNavBar
          currentIdentity={currentIdentity}
          identities={identities}
          isNavMenuOpen={isNavMenuOpen}
        />
      ) : (
        <UnauthenticatedNavBar hideJoinLink={hideJoinLink} isNavMenuOpen={isNavMenuOpen} />
      )}
    </div>
  );
};

NavBar.propTypes = {
  account: PropTypes.object,
  currentIdentity: PropTypes.object,
  hideJoinLink: PropTypes.bool,
  identities: PropTypes.arrayOf(PropTypes.object),
  isNavMenuOpen: PropTypes.bool.isRequired,
};

export default NavBar;
